import React, { useRef, useState } from "react";
import { Message } from "primereact/message";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import axios from "axios";
import {Toast} from "primereact/toast";


export const OpayoCheckout = ({amount, cancelTopup, currency, allowCheckout}) => {
    const countries = useSelector(state => state.mopriSettings.countries);
    const topup = useSelector(state => state.topup);
    const mopriSettings = useSelector(state => state.mopriSettings);
    const userAuth = useSelector(state => state.userAuth);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);

    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
    const [address1, setAddress1] = useState(userAuth?.address1);
    const [address2, setAddress2] = useState(userAuth?.address2);
    const [address3, setAddress3] = useState(userAuth?.address3);
    const [city, setCity] = useState(userAuth?.city);
    const [postalCode, setPostalCode] = useState(userAuth?.postalCode);
    const [country, setCountry] = useState(userAuth?.country);
    const [telNumber, setTelNumber] = useState(userAuth?.telNumber);
    const [error, setError] = useState(null);

    const myToast = useRef(null);

    const handleInputChange = (e) => {
        setTelNumber(e.target.value);
        setError(null); // Clear any previous error on input change
    };

    const validateTelNumber = () => {
        if (!/^\+\d+$/.test(telNumber)) {
            setError('Please enter a valid international telephone number (e.g., +27215555555).');
            return false;
        }
        // You can add more specific length or format validation here if needed
        return true;
    };

    const handleBlur = () => {
        validateTelNumber();
    };

    const handleOpayoPayment = async () => {
        setSubmitButtonDisabled(true);
        let vendorName, integrationKey, integrationPassword
        try {
            // Get the vendor name
            if (mopriSettings.gatewaySettings.opayoSandbox === 'true') {
                vendorName = mopriSettings.gatewaySettings.opayoSandboxVendorName
                integrationKey = mopriSettings.gatewaySettings.opayoSandboxIntegrationKey
                integrationPassword = mopriSettings.gatewaySettings.opayoSandboxIntegrationPassword
            } else {
                vendorName = mopriSettings.gatewaySettings.opayoProductionVendorName
                integrationKey = mopriSettings.gatewaySettings.opayoProductionIntegrationKey
                integrationPassword = mopriSettings.gatewaySettings.opayoProductionIntegrationPassword
            }

            // Verify address complete
            if (!address1 || !address2 || !address3 || !country || !postalCode || error) {
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'Please complete all address fields to continue.', life: 10000});
                throw new Error('Please complete address details to continue');
            } else {

                // Call backend to prepare Opayo payment
                const response = await axios.post(`${apiURL}/api/gateway/initiate-opayo-payment`, {
                    "vendorName": vendorName,
                    "amount": amount,
                    "currency": mopriSettings.internationalSettings.localizationCountry === 'GBR' ? 'GBP' : 'EUR',
                    "description": "Mopri Credit Top-Up",
                    "customerEmail": userAuth.email,
                    "isSandbox": mopriSettings.gatewaySettings.opayoSandbox === 'true',
                    "integrationKey": integrationKey,
                    "integrationPassword": integrationPassword,
                    "uid": userAuth.mopriUID,
                    "userGUID": userAuth.userGUID,
                    "address1": address1,
                    "address2": address2,
                    "address3": address3,
                    "country": country,
                    "postalCode": postalCode,
                    "city": city,
                    "telNumber": telNumber,
                    "firstName": userAuth.firstName,
                    "lastName": userAuth.lastName,
                    "appURL": window.location.origin
                });

                if (response.data) {
                    let data = response.data;
                    if (!data?.nextURL) {
                        myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'No redirect URL received from payment provider', life: 5000});
                        throw new Error('No redirect URL received from payment provider');
                    }
                    // Redirect to payment gateway.
                    console.log('DO redirect => ', data.nextURL);
                    window.location.href = data.nextURL;
                } else {
                    myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'No redirect URL received from payment provider', life: 5000});
                }
            }
        } catch (error) {
            console.error("Payment initiation error:", error);
        } finally {
            setSubmitButtonDisabled(false);
        }
    };

    return (
        <div className="grid" style={{paddingBottom: '20px'}}>
            <Toast ref={myToast} />
            <div className="col-12">
                <div className="flex align-items-center">
                    <img
                        src="img/opayo.png"
                        alt={"Opayo"}
                        style={{
                            height: '60px',
                            width: 'auto',
                        }}
                    />
                </div>
            </div>
            <div className="col-12">
                <Message severity="info" text="Your address and telephone is required to complete the topup." className="w-full justify-content-start" />
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <InputText
                        id="address1"
                        value={address1}
                        onChange={(e) => setAddress1(e.target.value)}
                        className="w-full"
                        disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="address1">Address Line 1</label>
                </FloatLabel>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <InputText
                        id="address2"
                        value={address2}
                        onChange={(e) => setAddress2(e.target.value)}
                        className="w-full"
                        disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="address2">Address Line 2</label>
                </FloatLabel>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <InputText
                        id="address3"
                        value={address3}
                        onChange={(e) => setAddress3(e.target.value)}
                        className="w-full"
                        disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="address3">Address Line 3</label>
                </FloatLabel>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <InputText
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className="w-full"
                        disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="city">City/Town</label>
                </FloatLabel>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <InputText
                        id="postalCode"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                        className="w-full"
                        disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="postalCode">Postal Code</label>
                </FloatLabel>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <Dropdown value={country}
                              onChange={(e) => setCountry(e.value)}
                              options={countries} optionLabel="countriesName"
                              optionValue="countriesCode"
                              placeholder="Select country"
                              className="w-full"
                              filter
                              disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="country">Country</label>
                </FloatLabel>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <FloatLabel>
                    <InputText
                        id="telNumber"
                        value={telNumber}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        mask="+9{1,}"
                        className={`w-full ${error ? 'p-invalid' : ''}`}
                        disabled={!allowCheckout || submitButtonDisabled}
                    />
                    <label htmlFor="telNumber">Telephone Number</label>
                </FloatLabel>
                {error && <small className="p-error">{error}</small>}
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <div className="p-fluid grid">
                    <div className="field col-6">
                        {allowCheckout &&
                            <Button label="Cancel"
                                    severity="danger" type="button"
                                    disabled={submitButtonDisabled}
                                    onClick={() => cancelTopup()}
                            />
                        }
                    </div>
                    <div className="field col-6">
                        <Button label={`Checkout ${amount ? `(${currency}${amount})` : ''}`}
                                severity="success"
                                disabled={submitButtonDisabled|| !allowCheckout}
                                onClick={() => handleOpayoPayment()}
                        />
                    </div>
                </div>
            </div>
            {submitButtonDisabled &&
                <div className="col-12">
                    <Message severity="success" text="Please wait, you are about to be redirected to Opayo to complete the topup." className="w-full justify-content-start" />
                </div>
            }
        </div>
    )
}